import React, { Component } from 'react';
import Loading from './Loading'

class ModalBase extends Component {
 
    render() {
        return (
            <div className={"edb-modal " + (this.props.fullScreen ? " modal-fullscreen" : "modal-no-fullscreen")}
                style={this.props.isOpen ? { display: 'block' } : {}}
                onClick={this.props.closeOutside && this.props.onCloseModal}>
                <div className="edb-modal-content edb-animate-bottom edb-margin-large-bottom" style={this.props.style}>

                    {!this.props.hideClose && <i className="fas fa-times edb-large edb-button edb-display-topright" title="Fechar" onClick={this.props.onCloseModal} style={{ zIndex: 1, backgroundColor: "transparent" }}></i>}
                    {this.props.showFullScreenButtons && !this.props.fullScreen && <i className="fas fa-expand edb-large edb-button edb-display-topright edb-hide-small" title="Tela inteira" onClick={() => this.props.onToggleFullscreen(true)} style={{ zIndex: 1, marginRight: "46px" }}></i>}
                    {this.props.showFullScreenButtons && this.props.fullScreen && <i className="fas fa-compress edb-large edb-button edb-display-topright  edb-hide-small" title="Sair da tela inteira" onClick={() => this.props.onToggleFullscreen(false)} style={{ zIndex: 1, marginRight: "46px" }}></i>}
                    <div className="edb-cell-row">
                        {this.props.loading && <Loading />}
                        {!this.props.loading && this.props.content}
                    </div>

                </div>
            </div>
        );
    }
}

export default ModalBase;
